/*
 * Product Selector
 *
 * Makes a simple select box or empty statement with a list
 * of Products it is passed, with the current product of the model
 * as the selected one. Obviously, we are talking v5 objects that
 * have relationships. In IDE terms, that is model.rel
 * 
 * e.g. a selector made by passing the resp data for a model into a product_region
 *     this.showChildView('product_region', new ProductSelector({ model: this.model, products: resp.data }));
 *
 * note the if_equals handlebar helper is required to make this form element work
 * public/js/views/helpers/if_equals.js
 *
 */

let product_template = `
<label for="product">Product</label>
{{#if show_empty}}
    No Products Available for this Account
{{else}}
<select name="product" class="form-control product">
    {{#each products}}
        <option value="{{this.id}}" {{#if_equals this.id ../selected_product}}selected{{/if_equals}}>{{this.attributes.name}}</option>
    {{/each}}
</select>
{{/if}}`;

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';

let ProductSelector = Marionette.View.extend({
    ui: {
        product: '.product',
    },
    events: {
        'change @ui.product': 'select_product',
    },
    template: Handlebars.compile(product_template),
    templateContext: function() {
        let products = this.getOption('products');
        if ( !this.selected_product ) this.selected_product = this.model.rel.get('product').id;
        let show_empty = false;
        if ( !products ) show_empty = true;
        return {
            show_empty,
            products,
            selected_product: this.selected_product
        };
    },
    onRender: function() {
        this.select_product();
    },
    select_product: function() {
        this.selected_product = this.ui.product.val();
        this.triggerMethod('change:product', this.selected_product);
    }
});

export default ProductSelector;
